import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import { texts } from 'utils/languages/fr';
import { ActionButton, CancelButton, CustomTextField } from 'components';
import { Box, Collapse, Paper } from '@mui/material';

const getDefaultFilters = obj => ({
    distributorName: obj?.distributorName || '',
});

const buildFilterPayload = filters => ({
    'distributorCompany.corporateName': filters.distributorName,
});

export default function RetrocessionsFilters({
    open,
    loading,
    savedFilters,
    applyFilters,
    onClose,
}) {
    const [customFilters, setCustomFilters] = useState(getDefaultFilters(savedFilters));
    const handleCancel = useCallback(() => {
        let defaults = getDefaultFilters();
        if (isEqual(defaults, customFilters)) {
            onClose();
        } else {
            setCustomFilters(defaults);
            applyFilters(buildFilterPayload(defaults));
        }
    }, [applyFilters, customFilters, onClose]);

    const handleApplyFilters = useCallback(() => {
        applyFilters(buildFilterPayload(customFilters));
    }, [applyFilters, customFilters]);

    const handleChange = name => e => {
        setCustomFilters(prevState => ({ ...prevState, [name]: e.target.value }));
    };

    return (
        <Collapse in={open}>
            <Paper sx={{ padding: 2, width: '100%' }}>
                <Box display="grid" gridTemplateColumns="auto auto auto">
                    <CustomTextField
                        label={texts.DISTRIBUTEUR}
                        placeholder={texts.DISTRIBUTEUR}
                        formControlProps={{ sx: { mb: 0 } }}
                        value={customFilters.distributorName}
                        onChange={handleChange('distributorName')}
                    />
                </Box>
                <Box textAlign="right">
                    <CancelButton disabled={loading} onClick={handleCancel}>
                        {texts.CANCEL}
                    </CancelButton>
                    <ActionButton loading={loading} disabled={loading} onClick={handleApplyFilters}>
                        {texts.APPLY}
                    </ActionButton>
                </Box>
            </Paper>
        </Collapse>
    );
}

RetrocessionsFilters.propTypes = {
    open: PropTypes.bool,
    loading: PropTypes.bool,
    savedFilters: PropTypes.object,
    applyFilters: PropTypes.func,
    onClose: PropTypes.func,
};
